import type { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { BookingLocationType, PaymentOption } from '@navio/nsdk';

/**
 * Profile-address policy for stationary create / pay / POS.
 *
 * - Create + POS: require a saved user-group address when a user group is known
 *   (`isLoggedIn && userGroupId != null` at the call site).
 * - Pay (existing booking): only stationary unpaid non-invoice bookings.
 */

/** Stationary unpaid bookings (not invoice / fully paid) need a profile address before pay. */
export function isStationaryUnpaidNeedingAddress(booking: BookingRecordDetailsCustomer): boolean {
  if (booking.locationType !== BookingLocationType.STATIONARY) {
    return false;
  }
  return !booking.order.isFullyPaid && booking.order.paymentOption !== PaymentOption.INVOICE;
}

/**
 * Single blocked rule for create/pay/confirm CTAs.
 * Safe default while loading: callers treat missing address as blocked until fetch resolves.
 */
export function isProfileAddressBlocked({ required, hasAddress }: { required: boolean; hasAddress: boolean }): boolean {
  return required && !hasAddress;
}
